import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorResponse } from '../models/api-error-response.model';

export function isApiErrorResponse(obj: unknown): obj is ApiErrorResponse {
  if (typeof obj !== 'object' || obj === null) return false;

  const potential = obj as Partial<ApiErrorResponse>;
  return (
    'Message' in potential || 'message' in potential || 'Code' in potential
  );
}

export function getApiErrorMessage(error: HttpErrorResponse): string {
  const err = error?.error;

  if (isApiErrorResponse(err)) {
    return (
      err?.Details?.Message?.toString() ||
      err?.Message?.toString() ||
      err?.message?.toString() ||
      'An unexpected server error occurred.'
    );
  }

  return error?.message || 'An unexpected error occurred.';
}
